/**
 * Helper pour les builds mobiles dédiés (PWA installables).
 *   - REACT_APP_MOBILE_CLIENT=true  → app "Mon Espace" pour clients TPCO
 *   - REACT_APP_MOBILE_STAFF=true   → (futur) app pour staff/admin
 */
export const MOBILE_CLIENT = process.env.REACT_APP_MOBILE_CLIENT === "true";
export const MOBILE_STAFF = process.env.REACT_APP_MOBILE_STAFF === "true";
export const IS_MOBILE_BUILD = MOBILE_CLIENT || MOBILE_STAFF;
